export const getPassengersConfig = (state) => state.passengersConfig;
